// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutofilladdressController from "./autofilladdress_controller"
application.register("autofilladdress", AutofilladdressController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import AutosaveWhileTypingController from "./autosave_while_typing_controller"
application.register("autosave-while-typing", AutosaveWhileTypingController)

import DuplicateCheckerController from "./duplicate_checker_controller"
application.register("duplicate-checker", DuplicateCheckerController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HideController from "./hide_controller"
application.register("hide", HideController)

import LocationsearchController from "./locationsearch_controller"
application.register("locationsearch", LocationsearchController)

import MapboxController from "./mapbox_controller"
application.register("mapbox", MapboxController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultistepFormController from "./multistep_form_controller"
application.register("multistep-form", MultistepFormController)

import NestedCheckboxFilterController from "./nested_checkbox_filter_controller"
application.register("nested-checkbox-filter", NestedCheckboxFilterController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import SearchAndFilter__SetSelectedSpaceController from "./search_and_filter/set_selected_space_controller"
application.register("search-and-filter--set-selected-space", SearchAndFilter__SetSelectedSpaceController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ShowOnRadioButtonValueController from "./show_on_radio_button_value_controller"
application.register("show-on-radio-button-value", ShowOnRadioButtonValueController)

import SliderController from "./slider_controller"
application.register("slider", SliderController)

import SyncFieldsWithSameIdController from "./sync_fields_with_same_id_controller"
application.register("sync-fields-with-same-id", SyncFieldsWithSameIdController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import TrixPasteController from "./trix_paste_controller"
application.register("trix-paste", TrixPasteController)
